import { Fragment, h, Host } from '@stencil/core';
import cn from 'classnames';
import { getConsumerSpecificData, indexDBBreadcrumbs, isAnalyticsEnabled, isIndexDBEnabled, parseCommonURLToRouterParts, productSelectorVirtualPageEvent, send, deepMerge, productCtas, PageNames, } from '@pes-ui/utils';
import PesRoute from '../pes-router/pes-route';
import { isAppRoutingEnabled, navigateWithRouter } from '../pes-router/utils';
import { updateProductCtasSelectorSettings } from '../UI/product-selector/product-selector-utils';
import { storeBreadcrumbs } from '../breadcrumbs/utils';
export class CategoryRangeCard {
  constructor() {
    var _a, _b;
    this.rangeUrl = ((_a = this.data) === null || _a === void 0 ? void 0 : _a.redirectUrl) || ((_b = this.data) === null || _b === void 0 ? void 0 : _b.url);
    this.onClickHandler = async (event) => {
      if (!isAppRoutingEnabled())
        return;
      event.preventDefault();
      const target = event.currentTarget;
      if (!isIndexDBEnabled()) {
        navigateWithRouter(this.route, target);
        return;
      }
      const { consumer, storageName } = getConsumerSpecificData(true, this.storageName);
      indexDBBreadcrumbs.setChannel(consumer);
      try {
        const breadcrumbs = await indexDBBreadcrumbs.getValidatedBreadcrumbs({
          storageName,
          key: this.currentPageStorageKey,
        });
        await storeBreadcrumbs({
          id: this.data.id,
          name: this.data.name,
          url: this.rangeUrl,
          subcategory: this.subCategory,
          breadcrumbs,
          pageName: PageNames.RANGE,
          storageName: this.storageName,
        });
      }
      catch (e) {
        console.error(`[PES]: Breadcrumbs can not be fetched from indexDB storage ${this.currentPageStorageKey}`, e);
      }
      navigateWithRouter(this.route, target);
    };
    this.openProductSelector = (selector, config) => (event) => {
      event.preventDefault();
      if (config.type === 'sc') {
        const host = document.createElement('pdp-sc-selector-modal');
        const frame = document.createElement('div');
        frame.id = 'widgetFrame';
        host.headerLabel = config.scLabel || 'Select your product';
        host.appendChild(frame);
        host.open = true;
        host.addEventListener('didClose', () => {
          document.body.removeChild(host);
        });
        document.body.appendChild(host);
      }
      selector.open(config, true);
      if (isAnalyticsEnabled()) {
        send(productSelectorVirtualPageEvent, { pageRangeId: this.data.id });
      }
    };
    this.getDescriptionText = (description, longDescription) => {
      if (description && longDescription) {
        return [
          this.getRangeWrapped(description, 's'),
          this.getRangeWrapped(longDescription, 'l'),
        ].join(' ');
      }
      if (description)
        return this.getRangeWrapped(description, 's');
      if (longDescription)
        return this.getRangeWrapped(longDescription, 'l');
    };
    this.getRangeCardContent = () => {
      if (!this.data)
        return null;
      const { name, badge, image, brandLogo, description, longDescription, masterRangeName, redirectUrl, domainName, commercialStatus, } = this.data;
      return [
        h("div", { class: "range-card__image-wrapper" }, image && (h("img", { loading: this.withImageLazy ? 'lazy' : 'eager', class: "range-card__image", src: image.url, alt: image.title })), brandLogo && (h("img", { loading: this.withImageLazy ? 'lazy' : 'eager', class: "range-card__brand-logo", src: brandLogo.url, alt: brandLogo.alt }))),
        h("div", { class: "range-card__wrapper" }, (commercialStatus === null || commercialStatus === void 0 ? void 0 : commercialStatus.label) && (h("pes-badge-wrapper", { class: "range-card__badge", type: commercialStatus.status, label: commercialStatus.label, color: commercialStatus.color })), badge && (h("pes-badge-wrapper", { class: "range-card__badge", type: badge.type, label: badge.label })), h("div", { class: "range-card__view" }, h("h3", null, h("span", { class: cn('range-card__name', { 'avoid-accents': this.avoidAccents }), innerHTML: this.getWrapped(name) })), this.getDescription(description, longDescription), masterRangeName && (h("span", { class: "range-card__master-range-name", innerHTML: this.rangePartofLabel.replace('#MasterRangeName#', masterRangeName) })), redirectUrl ? (h("qds-standalone-link", { size: "standard", importance: "standard", class: "range-card__view-prod-label", iconName: "arrow-top-right-on-square" }, `${this.viewOnLabel.replace('#domain_name#', '')} ${domainName}`)) : (h("qds-standalone-link", { size: "standard", importance: "standard", class: "range-card__view-prod-label" }, this.getLinkText())))),
      ];
    };
    this.data = undefined;
    this.rangePartofLabel = undefined;
    this.viewOnLabel = undefined;
    this.productRelationsViewProdLabel = undefined;
    this.rangeProductsViewDetailsLabel = undefined;
    this.subcategoryView = false;
    this.avoidAccents = undefined;
    this.withImageLazy = true;
    this.currentPageStorageKey = undefined;
    this.storageName = undefined;
    this.subCategory = undefined;
    this.selectorExtraOptions = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  componentWillLoad() {
    if (isAppRoutingEnabled()) {
      const { pageType, pageId } = parseCommonURLToRouterParts(this.rangeUrl);
      this.route = new PesRoute({ page: pageType, pageId });
      this.rangeUrl = this.route.url;
    }
    this.selectorExtraOptions = updateProductCtasSelectorSettings(this.data.selectorConfig, productCtas.buttons);
  }
  updatedSelectorConfig(config) {
    return deepMerge(config, { scOptions: this.selectorExtraOptions });
  }
  getLinkText() {
    return this.data.productsCount > 0
      ? this.productRelationsViewProdLabel
      : this.rangeProductsViewDetailsLabel;
  }
  getRangeWrapped(text, type) {
    if (type === 's')
      return `<!--RANGE-SHORTDESC_BEGIN-->${text}<!--RANGE-SCHORTDESC_END-->`;
    if (type === 'l')
      return `<!--RANGE-LONGDESC_BEGIN-->${text}<!--RANGE-LONGDESC_END-->`;
    return text;
  }
  getDescription(description, longDescription) {
    const descriptionText = this.getDescriptionText(description, longDescription);
    if (!descriptionText) {
      return null;
    }
    return (h("div", { class: cn('range-card__description', { 'avoid-accents': this.avoidAccents }), innerHTML: descriptionText }));
  }
  getWrapped(text) {
    return `<!--RANGE-NAME_BEGIN-->${text}<!--RANGE-NAME_END-->`;
  }
  getProductSelector() {
    if (this.data.selectorConfig && this.data.selectorConfig.config) {
      return (h("pes-product-selector", { config: this.updatedSelectorConfig(this.data.selectorConfig.config), renderFunction: (selector) => (h("qds-standalone-link", { size: "standard", importance: "standard", class: "range-card__product-selector-link", onClick: this.openProductSelector(selector, this.updatedSelectorConfig(this.data.selectorConfig.config)) }, this.data.selectorConfig.categoryLabel)) }));
    }
  }
  render() {
    if (!this.data) {
      return null;
    }
    const { id, redirectUrl, url } = this.data;
    const shouldRefresh = url || redirectUrl;
    return (h(Host, { class: cn({ sub: this.subcategoryView }) }, shouldRefresh ? (h(Fragment, null, h("a", { class: "range-card", href: this.rangeUrl, target: redirectUrl ? '_blank' : '_self', onClick: this.onClickHandler }, this.getRangeCardContent()), this.getProductSelector())) : (h("pes-router-link", { page: "range", pageId: id }, h(Fragment, null, h("a", { class: "range-card", id: id, href: "#" }, this.getRangeCardContent()), this.getProductSelector())))));
  }
  static get is() { return "pes-category-range-card"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["category-range-card.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["category-range-card.css"]
    };
  }
  static get properties() {
    return {
      "data": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TRange",
          "resolved": "{ id: string; name: string; description?: string; longDescription?: string; masterRangeName: string; productsCount?: number; badge?: TProductBadge; commercialStatus?: TProductCommercialBadge; image: { url: string; title?: string; }; brandLogo?: { url: string; alt?: string; }; brand?: string; redirectUrl: string; url?: string; domainName: string; selectorConfig?: { config: TProductSelectorConfig; categoryLabel: string; label: string; rangeId: string; labels: { removeFromCartLabel: string; removeFromMyProductsLabel: string; addToCartLabel: string; addToMyProductsLabel: string; }; }; }",
          "references": {
            "TRange": {
              "location": "import",
              "path": "../category-subcategory-listing/types"
            }
          }
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "data for range card"
        }
      },
      "rangePartofLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "label for \"Part of #MasterRangeName#\""
        },
        "attribute": "range-partof-label",
        "reflect": false
      },
      "viewOnLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "label for \"View on #domain_name#\""
        },
        "attribute": "view-on-label",
        "reflect": false
      },
      "productRelationsViewProdLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "label for \"View products\""
        },
        "attribute": "product-relations-view-prod-label",
        "reflect": false
      },
      "rangeProductsViewDetailsLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "label for \"View details\""
        },
        "attribute": "range-products-view-details-label",
        "reflect": false
      },
      "subcategoryView": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "enable view for subcategory page"
        },
        "attribute": "subcategory-view",
        "reflect": false,
        "defaultValue": "false"
      },
      "avoidAccents": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "avoid-accents",
        "reflect": false
      },
      "withImageLazy": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "loading = \"lazy | eager\" for card image"
        },
        "attribute": "with-image-lazy",
        "reflect": false,
        "defaultValue": "true"
      },
      "currentPageStorageKey": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [{
              "name": "example",
              "text": "SUBCATEGORY/4200"
            }],
          "text": "key for getting breadcrumbs from the indexDB"
        },
        "attribute": "current-page-storage-key",
        "reflect": false
      },
      "storageName": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "storageName in indexDB for saving breadcrumbs"
        },
        "attribute": "storage-name",
        "reflect": false
      },
      "subCategory": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TSubCategory",
          "resolved": "{ id: string; name: string; description?: string; badge?: TProductBadge; url?: string; ranges: TRange[]; sdlCategoryPromo?: TSDLPromoBlock; }",
          "references": {
            "TSubCategory": {
              "location": "import",
              "path": "../category-subcategory-listing/types"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "subcategory data with TSubCategory properties"
        }
      }
    };
  }
  static get states() {
    return {
      "selectorExtraOptions": {}
    };
  }
  static get elementRef() { return "el"; }
}
